// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAeVTCvTy54ZGLJI4K7Ml5Zne-_KZeR5j0',
    authDomain: 'jeferson-carvalho.firebaseapp.com',
    databaseURL: 'https://jeferson-carvalho.firebaseio.com',
    projectId: 'jeferson-carvalho',
    storageBucket: 'jeferson-carvalho.appspot.com',
    messagingSenderId: '611569922101',
    appId: '1:611569922101:web:7f7f8f724ea52216e5c17c',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
